import { rtkApi } from '@/apis/rtkApi';

export interface EmailPreferences {
  contract: {
    enabled: boolean;
    stages: {
      draft?: boolean;
      negotiating?: boolean;
      awaiting_signatures?: boolean;
      ratified?: boolean;
      inspection_pending?: boolean;
      repair_requested?: boolean;
      repair_negotiating?: boolean;
      escrow?: boolean;
      completed?: boolean;
    };
  };
  interestRate: {
    enabled: boolean;
  };
  system: {
    enabled: boolean;
  };
  marketing: {
    enabled: boolean;
  };
  shopping: {
    enabled: boolean;
  };
}

export const userPreferencesApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmailPreferences: builder.query<EmailPreferences, void>({
      query: () => ({ url: `/user/email-preferences` }),
      providesTags: ['User Email Preferences'],
    }),
    updateEmailPreferences: builder.mutation<
      EmailPreferences,
      EmailPreferences
    >({
      query: (preferences) => ({
        url: `/user/email-preferences`,
        method: 'PUT',
        data: preferences,
      }),
      invalidatesTags: ['User Email Preferences'],
    }),
  }),
});

export const {
  useGetEmailPreferencesQuery,
  useUpdateEmailPreferencesMutation,
} = userPreferencesApi;
